import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Lesson} from "../../../types/interfaces";
import {PopoverComponent} from "../popover/popover.component";
import {ModalController, PopoverController} from "@ionic/angular";
import {EditChildPhotoComponent} from "../modals/edit-child-photo/edit-child-photo.component";
import {LoyaltyProgramInfoComponent} from "../modals/loyalty-program-info/loyalty-program-info.component";

@Component({
    selector: 'app-program-item',
    templateUrl: './program-item.component.html',
    styleUrls: ['./program-item.component.scss'],
})
export class ProgramItemComponent implements OnInit {

    @Input() title: string = '';
    @Input() share: boolean = false;
    @Input() type: string = '';
    @Input() refUrl: string | undefined = '';


    @Output() openDetails: EventEmitter<any> = new EventEmitter();

    constructor(
        public popoverController: PopoverController,
        private modalCtrl: ModalController
    ) {
    }

    ngOnInit() {
    }

    showDetails() {
        this.openDetails.emit();
    }

    async presentSharePopover(e: Event) {

        const popover = await this.popoverController.create({
            component: PopoverComponent,
            showBackdrop: false,
            size: "cover",
            side: "top",
            event: e,
            cssClass: 'popover-class share-popover',
            alignment: "start",
            mode: "ios",
            arrow: true,
            componentProps: {
                isSharePopover: true,
                refUrl: this.refUrl

            }
        });

        await popover.present();

        const {role} = await popover.onDidDismiss();

    }


    async openProgramInfoModal() {
        const modal = await this.modalCtrl.create({
            component: LoyaltyProgramInfoComponent,
            // cssClass: this.type ==='cashback_program' ? 'program-details-modal cashback': 'program-details-modal',
            cssClass: 'auto-height',
            componentProps: {
                type: this.type,
                refUrl: this.refUrl,
            }


        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }
}
